export const SignUp = async ({ BeURL, email, contact, fullName, password, otp, role, departments, isInstructor , state}) => {
    try{
        const response = await fetch(`${BeURL}/signup`,{
            method: "POST",
            credentials :'include',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, contact, fullName, password, otp, role, departments, isInstructor ,state}),
        });
        return response.json();
    }
    catch(err){
        console.log("SIGNUP SERVICE ERROR", err);
    }
}
